import { createRoute } from '@tanstack/react-router'
import { rootRoute } from 'router/root-route'
import { z } from 'zod'

import { AuthRedirect } from '../components/AuthRedirect'

const searchSchema = z.object({
  auth_code: z.string(),
  state: z.string()
})

export const authRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth-redirect',
  component: AuthRedirect,
  validateSearch: searchSchema
})
